export const OPPORTUNITY_TYPES = {
  CREATOR: 'creator_needed',
  PHOTOGRAPHER: 'photographer_needed',
  VIDEOGRAPHER: 'videographer_needed',
  BOTH_CREATORS: 'both_creators_needed',
  MODEL: 'model_needed',
  BOTH: 'both',
  CREATIVE_COLLABORATION: 'creative_collaboration',
  PROFILE: 'profile',
} as const;

export type OpportunityTypeValue = typeof OPPORTUNITY_TYPES[keyof typeof OPPORTUNITY_TYPES];
